export const formatNumber = (
  value: number,
  options?: Intl.NumberFormatOptions,
): string => {
  return value.toLocaleString(undefined, options)
}
